import { collection, doc, getDoc, getDocs, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export class Project
{
	constructor(name, year, status)
	{
		this.name = name;
		this.year = year;
		this.status = status;
		this.id = name + " " + year;
	}

	async submitAsNewProject()
	{
		const {id, ...rest} = this;
		var projectRef = doc(db, "Project", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Project", id), { ...rest });
			return resp;
		}
	}

	static async submitAsNewProject(p)
	{
		const {id, ...rest} = p;
		var projectRef = doc(db, "Project", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Project", id), { ...rest });
			return resp;
		}
	}

	static async submitUpdateProject(p)
	{
		const {id, ...rest} = p;
		let resp = await setDoc(doc(db, "Project", id), { ...rest });
		return resp;
	}

	static async getAll() {
		return await getCollection("Project");
	}

	static async deleteAndUpdate(selection,projects,setProjects)
	{
		projects = projects.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Project", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setProjects(projects);
	}
}